export const DayOfWeekTranslation = [
  { ee: 'Su', eee: 'Sun', eeee: 'Sunday' },
  { ee: 'Mo', eee: 'Mon', eeee: 'Monday' },
  { ee: 'Tu', eee: 'Tue', eeee: 'Tuesday' },
  { ee: 'We', eee: 'Wed', eeee: 'Wednesday' },
  { ee: 'Th', eee: 'Thu', eeee: 'Thursday' },
  { ee: 'Fr', eee: 'Fri', eeee: 'Friday' },
  { ee: 'Sa', eee: 'Sat', eeee: 'Saturday' },
] as const;
